<template>
    <div class="newsList">
        <div class="conList">
            <div class="list">
                <ul>
                    <li v-for="news in newList" @click="geDetail(news)">
                        <div class="itemCon">
                            <div class="leftCon">
                                <div class="item1"><p>{{news.title}}</p></div>
                                <div class="item2">
                                    <img src="@/assets/images/template/home_icon1.png"/>
                                    <time>{{news.ctime|time}}</time>
                                </div>
                            </div>
                            <div class="rightCon"><img :src="news.imageUrl"/></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    require('@/assets/css/news.css');
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import api from '@/plugins/api'
    export default {
        name: "indexNews",
        computed: {
            ...mapState(['locale']),
        },
        filters: {
            time(longTime) {
                return Util.formatDate(longTime,"yyyy-MM-dd hh:mm:ss");
            }
        },
        data(){
            return{
                newList:[],
                langs:JSON.parse(process.env.VUE_APP_LANG)
            }
        },
        methods:{
            getNews(){
                if (this.locale == "vn") {
                    this.langs = this.langs.vn
                } else {
                    this.langs = this.langs.en
                }
                let data = {
                    limit: 5,
                    lang: this.langs
                };
                api.getArticleAllList(this.$qs.stringify(data)).then(res => {
                    if (res.data.code == 0) {
                        this.newList  = res.data.data;
                    }
                })
            },
            geDetail(news) {
                this.$bus.$emit('loading', false);
                this.$router.push({
                    path: "/home/newsDetail",
                    query: {
                        id: news.articleId,
                        title: this.$t("trade.products.aboutNews")
                    }
                });
            },
        },
        mounted() {
            this.getNews()
        },
    }
</script>
